export default class Planner {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.inputs = this.DOM.el.querySelectorAll('[data-planner-input]');
        this.DOM.button = this.DOM.el.querySelector('[data-planner-button]');
        this.initEvents();
    }

    initEvents() {
        const queryParams = {};
        const url = window.location.origin;

        /* Add event listeners */
        if (this.DOM.inputs) {
            this.DOM.inputs.forEach((element) => {
                element.addEventListener("change", (e) => {
                    queryParams[element.getAttribute('data-planner-input-name')] = e.target.value;
                });
            });
        }

        if (this.DOM.button) {
            this.DOM.button.addEventListener("click", () => {
                sessionStorage.removeItem('vehicle');

                let queryString = '';

                if (queryParams.hasOwnProperty('licensePlate')) {
                    queryString += '?licensePlate=' + queryParams.licensePlate;
                }

                if (queryParams.hasOwnProperty('mileage')) {
                    if (queryString.includes('licensePlate')) {
                        queryString += '&mileage=' + queryParams.mileage;

                    } else {
                        queryString += '?mileage=' + queryParams.mileage;
                    }
                }

                window.location.replace(url + '/werkplaatsplanner' +  queryString);
            });
        }
    }
}

const plannerNodes = Array.from(document.querySelectorAll('[data-planner]'));
if (plannerNodes !== null) {
    plannerNodes.forEach((node) => { new Planner(node); });
}
